
import React, { ReactNode } from 'react';

interface CardProps {
    children: ReactNode;
    className?: string;
    title?: string;
}

const Card: React.FC<CardProps> = ({ children, className = '', title }) => {
    return (
        <div className={`bg-card border border-border rounded-lg shadow-sm ${className}`}>
            {title && (
                <div className="p-4 border-b border-border">
                    <h3 className="text-lg font-semibold text-text-primary">{title}</h3>
                </div>
            )}
            <div className="p-4">
                {children}
            </div>
        </div>
    );
};

export default Card;
